export default __webpack_public_path__ + "static/jogowaga-logo-8241f496d03e15250925bb4015e650c6.jpeg";